import React from 'react';
import {Link} from 'gatsby';
import moment from 'moment';
import 'moment/locale/nl';

moment.locale('nl');

interface DataContext {
  additionalData: {
    pageSettings: Queries.config_pages__page_settings;
    latestNews: Queries.node__news[];
  };
}
export default function LatestNews({additionalData}: DataContext): React.JSX.Element {
  return (
    <section className="vl-region">
      <div className="vl-layout">
        <div className="vl-grid vl-grid--is-stacked">
          <div className="vl-col--12-12">
            <h2 className="vl-title vl-title--h2 vl-u-spacer-bottom--none">
              Nieuwsberichten
            </h2>
          </div>

          {additionalData.latestNews.map(
            (newsNode: Queries.node__news, idx: number) => (
              <div
                key={idx}
                className="vl-col--4-12 vl-col--6-12--m vl-col--12-12--s"
              >
                <Link
                  to={newsNode.path.alias}
                  key={idx}
                  className="vl-spotlight vl-spotlight--no-border"
                >
                  <article role="none">
                    <h3 className="vl-spotlight__title line-clamp-2">
                      {newsNode.title}
                    </h3>
                    <div className="vl-spotlight__text">
                      <div className="vl-icon-wrapper">
                        <i className="vl-icon vl-icon--before vl-icon--light vl-vi vl-vi-calendar"></i>
                        <time
                          dateTime={newsNode.field_date}
                          className="vl-annotation"
                        >
                          {moment(newsNode.field_date).format('D MMMM YYYY')}
                        </time>
                      </div>
                    </div>
                    <div
                      className="vl-spotlight__text line-clamp-4"
                      dangerouslySetInnerHTML={{
                        __html: newsNode.body?.processed,
                      }}
                    />
                  </article>
                </Link>
              </div>
            ),
          )}
          <div className="vl-col--12-12">
            <Link
              to={additionalData.pageSettings.relationships.field_news_page.path.alias}
              className="vl-button"
              vl-button=""
            >
              <span className="vl-button__label">
                Lees alle nieuwsberichten
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
